import React from 'react';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const FolderDeletionDialog = ({ theme }) => {
  const { folder } = Selectors.useDatasetFolderDeletionDialog();
  const hide = Events.useHideDeleteDatasetFolder();
  const deleteData = Events.useDeleteDatasetFolder(folder);
  return (
    <ActionDialogContent
      items={[folder]}
      hide={hide}
      theme={theme}
      onSubmit={deleteData}
      entity="dataset.folder"
      className="aridhia-dataset-attachment-deletion-dialog"
    />
  );
};

export default FolderDeletionDialog;
